<script setup lang="ts">
import { ref } from 'vue';
import { Modal, Button } from 'ant-design-vue';

import type {
  FileAiReviewFragmentFragment,
  FileFragmentFragment,
} from '@/graphql/generated/graphql';

defineProps<{
  file: FileFragmentFragment;
  fileAiReview: FileAiReviewFragmentFragment;
}>();

const detailModalOpen = ref(false);

const onShowDetailModal = () => {
  detailModalOpen.value = true;
};

const closeDetailModal = () => {
  detailModalOpen.value = false;
};

const fileAiReviewDetailModalBodyStyle = {
  height: 'calc(100dvh - 7rem)',
  maxHeight: 'calc(100dvh - 7rem)',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  padding: '12px 24px 16px',
} as const;

</script>

<template>
  <div>
    <Button @click="onShowDetailModal">
      View
    </Button>
    <Modal
      v-if="detailModalOpen"
      title="AI review detail"
      :open="detailModalOpen"
      width="min(1200px, 98vw)"
      centered
      :body-style="fileAiReviewDetailModalBodyStyle"
      :footer="null"
      @cancel="closeDetailModal"
    >
      <FileAiReviewView :file="file" :file-ai-review="fileAiReview" />
    </Modal>
  </div>
</template>
